import { MODULE_KEY, ROLES_KEYS, UserProcessStatus, UserProcessStatusType } from '@interfaces';
import { statusesAllowedPerPath } from '@constants';

export interface MenuItem {
  getRouterLink: (userProcessId?: string) => string[];
  mainLabelKey: string;
  svgIcon?: string;
  class?: string;
  isDisabled?: (userProcessStatus?: UserProcessStatusType) => boolean;
  showOnMobile?: boolean;
  disabledItemTooltip?: string;
  moduleKey: MODULE_KEY;
}

export const sideMenuConfig: { [key in ROLES_KEYS]: MenuItem[] } = {
  [ROLES_KEYS.Admin]: [
    {
      mainLabelKey: 'MANAGEMENT.MENU.TASKS',
      getRouterLink: () => ['/tasks'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.TASKS,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.APPLICATIONS-MANAGEMENT',
      getRouterLink: () => ['/management/applications-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.RESIDENCE_PERMIT,
    },
    {
      mainLabelKey: 'COMMON.LAYOUT.CANDIDATE_VERIFICATION',
      getRouterLink: () => ['/cvm/cv-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.CVM,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.TRACKING',
      getRouterLink: () => ['/tracking'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.TRACKING,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.WORK_PERMITS',
      getRouterLink: () => ['/work-permits'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.WORK_PERMIT,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.SCHEDULED_VISITS',
      getRouterLink: () => ['/management/visits-list'],
      class: 'visits-list',
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.VISITS_CALENDAR_NEW',
      getRouterLink: () => ['/management/visits-calendar-new'],
      class: 'visits-calendar-new',
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.FOREIGNERS',
      getRouterLink: () => ['/management/foreigners-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.COMPANIES',
      getRouterLink: () => ['/management/companies-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.EMPLOYEES',
      getRouterLink: () => ['/management/employees-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.OFFICES',
      getRouterLink: () => ['/management/offices-list'],
      isDisabled: () => false,
      showOnMobile: false,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.VOIVODESHIPS',
      getRouterLink: () => ['/management/voivodeships-list'],
      isDisabled: () => false,
      showOnMobile: false,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.DOCUMENTS-STATEMENTS',
      getRouterLink: () => ['/management/documents-statements'],
      isDisabled: () => false,
      showOnMobile: false,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.PARTNERS_AND_PAYOUTS',
      getRouterLink: () => ['/partners'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
  ],
  [ROLES_KEYS.Employee]: [
    {
      mainLabelKey: 'MANAGEMENT.MENU.TASKS',
      getRouterLink: () => ['/tasks'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.TASKS,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.APPLICATIONS-MANAGEMENT',
      getRouterLink: () => ['/management/applications-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.RESIDENCE_PERMIT,
    },
    {
      mainLabelKey: 'COMMON.LAYOUT.CANDIDATE_VERIFICATION',
      getRouterLink: () => ['/cvm/cv-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.CVM,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.TRACKING',
      getRouterLink: () => ['/tracking'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.TRACKING,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.WORK_PERMITS',
      getRouterLink: () => ['/work-permits'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.WORK_PERMIT,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.SCHEDULED_VISITS',
      getRouterLink: () => ['/management/visits-list'],
      class: 'visits-list',
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.VISITS_CALENDAR',
      getRouterLink: () => ['/management/visits-calendar-new'],
      class: 'visits-calendar-new',
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.FOREIGNERS',
      getRouterLink: () => ['/management/foreigners-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.COMPANIES',
      getRouterLink: () => ['/management/companies-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
  ],
  [ROLES_KEYS.Team_Leader]: [
    {
      mainLabelKey: 'MANAGEMENT.MENU.TASKS',
      getRouterLink: () => ['/tasks'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.TASKS,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.APPLICATIONS-MANAGEMENT',
      getRouterLink: () => ['/management/applications-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.RESIDENCE_PERMIT,
    },
    {
      mainLabelKey: 'COMMON.LAYOUT.CANDIDATE_VERIFICATION',
      getRouterLink: () => ['/cvm/cv-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.CVM,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.TRACKING',
      getRouterLink: () => ['/tracking'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.TRACKING,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.WORK_PERMITS',
      getRouterLink: () => ['/work-permits'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.WORK_PERMIT,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.SCHEDULED_VISITS',
      getRouterLink: () => ['/management/visits-list'],
      class: 'visits-list',
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.VISITS_CALENDAR',
      getRouterLink: () => ['/management/visits-calendar-new'],
      class: 'visits-calendar-new',
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.FOREIGNERS',
      getRouterLink: () => ['/management/foreigners-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.COMPANIES',
      getRouterLink: () => ['/management/companies-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.EMPLOYEES',
      getRouterLink: () => ['/management/employees-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.VOIVODESHIPS',
      getRouterLink: () => ['/management/voivodeships-list'],
      isDisabled: () => false,
      showOnMobile: false,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.PARTNERS_AND_PAYOUTS',
      getRouterLink: () => ['/partners'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
  ],
  [ROLES_KEYS.Field_Consultant]: [
    {
      mainLabelKey: 'MANAGEMENT.MENU.TASKS',
      getRouterLink: () => ['/tasks'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.TASKS,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.APPLICATIONS-MANAGEMENT',
      getRouterLink: () => ['/management/applications-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.RESIDENCE_PERMIT,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.SCHEDULED_VISITS',
      getRouterLink: () => ['/management/visits-list'],
      class: 'visits-list',
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.VISITS_CALENDAR',
      getRouterLink: () => ['/management/visits-calendar-new'],
      class: 'visits-calendar-new',
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
    {
      mainLabelKey: 'MANAGEMENT.MENU.FOREIGNERS',
      getRouterLink: () => ['/management/foreigners-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.OTHER,
    },
  ],
  [ROLES_KEYS.Foreigner]: [
    {
      mainLabelKey: 'COMMON.LAYOUT.PRE_SURVEY',
      getRouterLink: (userProcessId: string) => {
        return userProcessId?.length ? ['/user-process', userProcessId, 'pre-survey'] : ['/purchase'];
      },
      svgIcon: 'datafile',
      class: 'pre-survey',
      moduleKey: MODULE_KEY.RESIDENCE_PERMIT,
      isDisabled: userProcessStatus => {
        if (!userProcessStatus) {
          return true;
        }

        const allowedStatuses = [UserProcessStatus.FILLING_PRE_SURVEY, UserProcessStatus.PRE_SURVEY_VERIFICATION];
        return !allowedStatuses.includes(userProcessStatus);
      },
      showOnMobile: true,
      disabledItemTooltip: 'COMMON.LAYOUT.DISABLED_ITEM_TOOLTIP',
    },
    {
      mainLabelKey: 'COMMON.LAYOUT.USER_DETAILS',
      getRouterLink: (userProcessId: string) => {
        return userProcessId?.length ? ['/user-process', userProcessId, 'personal-details'] : ['/purchase'];
      },
      svgIcon: 'person',
      class: 'foreigner-details',
      moduleKey: MODULE_KEY.RESIDENCE_PERMIT,
      isDisabled: userProcessStatus => {
        if (!userProcessStatus) {
          return true;
        }
        return !statusesAllowedPerPath.personalDetails.includes(userProcessStatus);
      },
      showOnMobile: true,
      disabledItemTooltip: 'COMMON.LAYOUT.DISABLED_ITEM_TOOLTIP',
    },
    {
      mainLabelKey: 'COMMON.LAYOUT.DOCUMENTS',
      getRouterLink: (userProcessId: string) => {
        return userProcessId?.length ? ['/user-process', userProcessId, 'documents'] : ['/purchase'];
      },
      svgIcon: 'document',
      class: 'foreigner-documents',
      moduleKey: MODULE_KEY.RESIDENCE_PERMIT,
      isDisabled: userProcessStatus => {
        if (!userProcessStatus) {
          return true;
        }
        return !statusesAllowedPerPath.documents.includes(userProcessStatus);
      },
      showOnMobile: true,
      disabledItemTooltip: 'COMMON.LAYOUT.DISABLED_ITEM_TOOLTIP',
    },
    {
      mainLabelKey: 'COMMON.LAYOUT.APPLICATION_PROCESSING',
      getRouterLink: (userProcessId: string) => {
        return userProcessId?.length ? ['/user-process', userProcessId, 'summary'] : ['/purchase'];
      },
      svgIcon: 'factcheck',
      class: 'foreigner-application-processing',
      moduleKey: MODULE_KEY.RESIDENCE_PERMIT,
      isDisabled: userProcessStatus => {
        if (!userProcessStatus) {
          return true;
        }
        const summaryEnabledForStatuses = [
          UserProcessStatus.REVIEW_DONE_POST_SUBMISSION_INSTRUCTIONS,
          UserProcessStatus.REVIEW_DONE_MOS_SUBMISSION_INSTRUCTIONS,

          UserProcessStatus.SELECTING_DOCUMENTS_SIGN_MODE,
          UserProcessStatus.DOCUMENTS_SENT_TO_OFFICE_BY_POST,
          UserProcessStatus.SIGNED_DOCUMENTS_RECEIVED,

          UserProcessStatus.APPOINTMENT_TO_SIGN_DOCS,
          UserProcessStatus.APPOINTMENT_TO_SUBMIT_TO_MOS,
          UserProcessStatus.APPOINTMENT_TO_VERIFY_DOCS,

          UserProcessStatus.AWAITING_IMMIGROF_VISIT_INFO__FROM_FOREIGNER,
          UserProcessStatus.AWAITING_IMMIGROF_VISIT_INFO__FROM_IMMIGROF,

          UserProcessStatus.IMMIGROF_VISIT_SCHEDULED,
          UserProcessStatus.IMMIGROF_VISIT_COMPLETED,
          UserProcessStatus.DECISION_ISSUED,
        ];
        const shouldBeDisabled = !summaryEnabledForStatuses.includes(userProcessStatus);
        return shouldBeDisabled;
      },
      showOnMobile: true,
      disabledItemTooltip: 'COMMON.LAYOUT.DISABLED_ITEM_TOOLTIP',
    },
  ],
  [ROLES_KEYS.Employer]: [
    {
      mainLabelKey: 'COMMON.LAYOUT.STAY_LEGALISATION',
      getRouterLink: () => ['/manager/company-employees-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.RESIDENCE_PERMIT,
    },
    {
      mainLabelKey: 'COMMON.LAYOUT.CANDIDATE_VERIFICATION',
      getRouterLink: () => ['/cvm/cv-list'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.CVM,
    },
    {
      mainLabelKey: 'COMMON.LAYOUT.TRACKING',
      getRouterLink: () => ['/tracking'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.TRACKING,
    },
    {
      mainLabelKey: 'COMMON.LAYOUT.WORK_PERMITS',
      getRouterLink: () => ['/work-permits'],
      isDisabled: () => false,
      showOnMobile: true,
      moduleKey: MODULE_KEY.WORK_PERMIT,
    },
  ],
};

// Foreigner's menu while a work-permit is displayed; the link gets the work-permit id.
export const foreignerWorkPermitMenuItems: MenuItem[] = [
  {
    mainLabelKey: 'COMMON.LAYOUT.MY_WORK_PERMIT',
    getRouterLink: (workPermitId: string) => ['/my-work-permit', workPermitId],
    svgIcon: 'document',
    class: 'foreigner-work-permit',
    moduleKey: MODULE_KEY.WORK_PERMIT,
    isDisabled: () => false,
    showOnMobile: true,
  },
];
